import { usePortalElement } from "@digits-shared/hooks/usePortalElement"

/**
 * Returns the element which hosts application drag and drop overlays. This element is outside of the main application content area
 * so that the overlays sit above other content.
 */
export function useDndRoot() {
  return usePortalElement("dnd-root", false, document.body, "beforeend")
}
